class JournalContents extends HTMLElement {
  connectedCallback() {
    const body = document.getElementById('journal-article-body');
    const navigation = this.querySelector('nav');
    const list = this.querySelector('ol');
    if (!body || !navigation || !list || list.children.length) return;
    const headings = [...body.querySelectorAll('h2')];
    headings.forEach((heading, index) => {
      if (!heading.id) heading.id = `journal-section-${index + 1}`;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      link.className = 'underline';
      item.append(link);
      list.append(item);
    });
    navigation.hidden = headings.length === 0;
  }
}
if (!customElements.get('journal-contents')) customElements.define('journal-contents', JournalContents);
